/**
 * FITLEASURE — Wishlist Core
 * ---------------------------
 * HOW TO INSTALL:
 * 1. Go to: Online Store → Themes → Actions → Edit Code
 * 2. Under "Assets", click "Add a new asset"
 * 3. Choose "Create a blank file"
 * 4. Name it: fitleasure-wishlist.js
 * 5. Paste this entire file and Save
 */

(function () {
  'use strict';

  /* =============================================
     STORAGE KEY
  ============================================= */
  var STORAGE_KEY = 'fl_wishlist';

  /* =============================================
     GET / SET WISHLIST
     Stored as array of wishlist IDs in localStorage.
     Each ID is either a plain product id (legacy entries,
     or products with no color option) or a composite
     "{product.id}-{color-handle}" key (see parseWishlistId).
  ============================================= */
  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  /* =============================================
     ADD / REMOVE / TOGGLE
  ============================================= */
  function isWishlisted(productId) {
    return getWishlist().indexOf(String(productId)) > -1;
  }

  function addToWishlist(productId) {
    var list = getWishlist();
    var id   = String(productId);
    if (list.indexOf(id) === -1) {
      list.push(id);
      saveWishlist(list);
    }
    updateAllButtons(id, true);
    updateWishlistCount();
    showToast('Added to wishlist');
  }

  function removeFromWishlist(productId) {
    var list = getWishlist();
    var id   = String(productId);
    list     = list.filter(function (i) { return i !== id; });
    saveWishlist(list);
    updateAllButtons(id, false);
    updateWishlistCount();
    showToast('Removed from wishlist');

    /* If on wishlist page, remove the card from the grid */
    var card = document.querySelector('.fl-wl-card[data-product-id="' + id + '"]');
    if (card) {
      card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      card.style.opacity    = '0';
      card.style.transform  = 'scale(0.95)';
      setTimeout(function () {
        card.remove();
        checkEmptyState();
      }, 300);
    }
  }

  function toggleWishlist(productId) {
    if (isWishlisted(productId)) {
      removeFromWishlist(productId);
    } else {
      addToWishlist(productId);
    }
  }

  /* =============================================
     UPDATE ALL HEART BUTTONS FOR A PRODUCT
  ============================================= */
  function updateAllButtons(productId, wishlisted) {
    var btns = document.querySelectorAll('.fl-wl-btn[data-product-id="' + productId + '"]');
    btns.forEach(function (btn) {
      btn.classList.toggle('is-wishlisted', wishlisted);
      btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    });
  }

  /* =============================================
     INITIALISE ALL HEART BUTTONS ON PAGE
  ============================================= */
  function initButtons() {
    var btns = document.querySelectorAll('.fl-wl-btn');
    btns.forEach(function (btn) {
      var id = btn.dataset.productId;
      if (!id) return;

      /* Set initial state */
      var wishlisted = isWishlisted(id);
      btn.classList.toggle('is-wishlisted', wishlisted);
      btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');

      /* Click handler — prevent navigation if inside a link */
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(id);
      });
    });
  }

  /* =============================================
     TOAST NOTIFICATION
  ============================================= */
  function showToast(message) {
    var existing = document.getElementById('fl-wl-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id  = 'fl-wl-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);

    /* Animate in */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('fl-wl-toast--visible');
      });
    });

    /* Animate out after 2.5s */
    setTimeout(function () {
      toast.classList.remove('fl-wl-toast--visible');
      setTimeout(function () { toast.remove(); }, 300);
    }, 2500);
  }

  /* =============================================
     PARSE WISHLIST ID
     Shopify product IDs are purely numeric, so the leading
     numeric segment is always the base product id. Anything
     after the first dash (if present) is the color handle.
     Legacy entries saved before colors were split have no
     color segment — colorHandle comes back empty and the
     caller falls back to the product's first variant, so old
     wishlist data keeps working without a migration step.
  ============================================= */
  function parseWishlistId(id) {
    var str = String(id);
    var firstDash = str.indexOf('-');
    if (firstDash === -1) {
      return { baseId: str, colorHandle: '' };
    }
    return {
      baseId: str.slice(0, firstDash),
      colorHandle: str.slice(firstDash + 1)
    };
  }

  /* =============================================
     WISHLIST PAGE — RENDER PRODUCTS
  ============================================= */
  function renderWishlistPage() {
    var container = document.getElementById('fl-wl-page-grid');
    if (!container) return;

    var list = getWishlist();

    if (list.length === 0) {
      checkEmptyState();
      return;
    }

    var baseIds = list.map(function (id) { return parseWishlistId(id).baseId; });

    /* Fetch all wishlisted products in one API call using /products.json */
    fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.products) { checkEmptyState(); return; }
        /* Filter only the products that are in our wishlist */
        var products = data.products.filter(function (p) {
          return baseIds.indexOf(String(p.id)) > -1;
        });
        renderCards(container, products, list);
      })
      .catch(function () {
        checkEmptyState();
      });
  }

  function renderCards(container, products, list) {
    /* One card per wishlist ENTRY, not per product -- the same
       product can appear twice if two of its colors are wishlisted. */
    var ordered = list.map(function (wlId) {
      var parsed  = parseWishlistId(wlId);
      var product = products.find(function (p) { return String(p.id) === parsed.baseId; });
      if (!product) return null;
      return { wlId: wlId, product: product, colorHandle: parsed.colorHandle };
    }).filter(Boolean);

    if (ordered.length === 0) {
      checkEmptyState();
      return;
    }

    container.innerHTML = '';

    ordered.forEach(function (entry) {
      var product     = entry.product;
      var wlId        = entry.wlId;
      var colorHandle = entry.colorHandle;

      /* Find the variant matching this entry's color. Color could be
         option1, option2, or option3 depending on the product, so check
         all three. Falls back to variants[0] for legacy entries with no
         color segment, or if no option value matches the saved handle
         (e.g. the color was later renamed or removed). */
      var variant = product.variants[0];
      if (colorHandle) {
        var colorVariants = product.variants.filter(function (v) {
          return [v.option1, v.option2, v.option3].some(function (opt) {
            if (!opt) return false;
            var handleized = opt.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            return handleized === colorHandle;
          });
        });
        /* Prefer an in-stock size of this color; only fall back to an
           out-of-stock one if every size of this color is sold out. */
        var matched = colorVariants.find(function (v) { return v.available; }) || colorVariants[0];
        if (matched) variant = matched;
      }

      /* products.json returns price as string e.g. "2069.00", not cents */
      var priceRaw   = parseFloat(variant.price);
      var price      = '₹' + priceRaw.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      var compareAt  = null;
      if (variant.compare_at_price) {
        var compareRaw = parseFloat(variant.compare_at_price);
        if (compareRaw > priceRaw) compareAt = '₹' + compareRaw.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }

      /* Prefer this variant's own image; fall back to the product's first image */
      var image = '';
      if (variant.featured_image && variant.featured_image.src) {
        image = variant.featured_image.src;
      } else if (product.images && product.images.length > 0) {
        image = product.images[0].src;
      }
      if (image && image.indexOf('//') === 0) image = 'https:' + image;

      var url   = '/products/' + product.handle + '?variant=' + variant.id;
      var title = product.title + (variant.title && variant.title !== 'Default Title' ? ' - ' + variant.title : '');

      /* Product-level availability (any variant in stock), not just this
         one color/size -- the button opens Quick View where the customer
         can pick any size or color, so it should only read "Out of Stock"
         when nothing on the whole product can be bought. */
      var productAvailable = product.variants.some(function (v) { return v.available; });

      var card = document.createElement('div');
      card.className = 'fl-wl-card';
      card.dataset.productId = wlId;

      card.innerHTML = [
        '<div class="fl-wl-card__img-wrap">',
          '<a href="' + url + '">',
            image ? '<img src="' + image + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '<div class="fl-wl-card__img-placeholder"></div>',
          '</a>',
          '<button class="fl-wl-btn is-wishlisted" data-product-id="' + wlId + '" aria-label="Remove from wishlist" aria-pressed="true">',
            '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>',
          '</button>',
        '</div>',
        '<div class="fl-wl-card__info">',
          '<div class="fl-wl-card__title-row">',
            '<a class="fl-wl-card__title" href="' + url + '">' + escapeHtml(title) + '</a>',
          '</div>',
          '<div class="fl-wl-card__price">',
            compareAt ? '<span class="fl-wl-card__price--compare">' + compareAt + '</span>' : '',
            '<span class="fl-wl-card__price--current">' + price + '</span>',
          '</div>',
          /* Opens the theme's native Quick View (same popup used on the
             collection grid) instead of adding a fixed variant directly.
             Lets the customer see the full product and pick their own
             size/color, and goes through the theme's real cart logic
             instead of a hand-written fetch. data-variant-id preselects
             this entry's wishlisted color when the popup opens. */
          '<button type="button" class="fl-wl-card__atc"' + (productAvailable ? '' : ' disabled') + ' data-handle="' + product.handle + '" data-variant-id="' + variant.id + '" data-button-quick-view aria-label="' + (productAvailable ? 'Quick view and add to cart' : 'Out of stock') + '">',
            '<quick-view-button></quick-view-button>',
            productAvailable ? 'Add to Cart' : 'Out of Stock',
          '</button>',
        '</div>'
      ].join('');

      container.appendChild(card);
    });

    /* Bind remove buttons on wishlist page */
    initButtons();

    /* No manual binding needed for .fl-wl-card__atc -- the quick-view-button
       custom element inside each one wires its own click handler
       automatically the moment it's connected to the DOM (standard
       Custom Elements behavior, applies even to elements inserted via
       innerHTML like this). */
  }

  function checkEmptyState() {
    var container = document.getElementById('fl-wl-page-grid');
    var empty     = document.getElementById('fl-wl-empty');
    if (!container) return;

    var cards = container.querySelectorAll('.fl-wl-card');
    if (cards.length === 0) {
      container.style.display = 'none';
      if (empty) empty.style.display = 'block';
    }
  }

  /* =============================================
     SHARE WISHLIST
  ============================================= */
  function initShareButton() {
    var btn = document.getElementById('fl-wl-share');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var list = getWishlist();
      if (list.length === 0) {
        showToast('Your wishlist is empty');
        return;
      }

      /* Build share URL with product IDs as query params */
      var url = window.location.origin + '/pages/wishlist?ids=' + list.join(',');

      if (navigator.share) {
        navigator.share({
          title: 'My Fitleasure Wishlist',
          url:   url
        }).catch(function () {});
      } else {
        /* Fallback — copy to clipboard */
        navigator.clipboard.writeText(url).then(function () {
          showToast('Wishlist link copied!');
        }).catch(function () {
          /* Final fallback for older browsers */
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
          showToast('Wishlist link copied!');
        });
      }
    });
  }

  /* =============================================
     LOAD SHARED WISHLIST FROM URL
     e.g. /pages/wishlist?ids=123,456,789
  ============================================= */
  function loadSharedWishlist() {
    var params = new URLSearchParams(window.location.search);
    var ids    = params.get('ids');
    if (!ids) return;

    var sharedIds = ids.split(',').filter(Boolean);
    if (sharedIds.length === 0) return;

    /* Merge shared IDs into current wishlist */
    var current = getWishlist();
    sharedIds.forEach(function (id) {
      if (current.indexOf(id) === -1) current.push(id);
    });
    saveWishlist(current);

    showToast('Wishlist loaded from shared link');
  }

  /* =============================================
     HELPERS
  ============================================= */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active + ' ' + amount
      : '₹' + amount;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* =============================================
     WISHLIST ICON COUNT (header badge)
  ============================================= */
  function updateWishlistCount() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('.fl-wl-count');
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* =============================================
     PUBLIC API
  ============================================= */
  window.FLWishlist = {
    get:       getWishlist,
    add:       addToWishlist,
    remove:    removeFromWishlist,
    toggle:    toggleWishlist,
    has:       isWishlisted,
    count:     function () { return getWishlist().length; }
  };

  /* Expose initButtons globally so other sections can reinit after rendering */
  window.flWishlistInitButtons = initButtons;

  /* =============================================
     INIT ON DOM READY
  ============================================= */
  function init() {
    loadSharedWishlist();
    initButtons();
    updateWishlistCount();
    renderWishlistPage();
    initShareButton();

    /* Watch for dynamically added product cards */
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          /* Check if the added node itself is a wishlist button */
          if (node.classList && node.classList.contains('fl-wl-btn')) {
            var id = node.dataset.productId;
            if (!id) return;
            var wishlisted = isWishlisted(id);
            node.classList.toggle('is-wishlisted', wishlisted);
            node.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
            node.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
            node.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              toggleWishlist(id);
            });
          }

          /* Check for wishlist buttons inside the added node */
          var btns = node.querySelectorAll ? node.querySelectorAll('.fl-wl-btn') : [];
          btns.forEach(function(btn) {
            var id = btn.dataset.productId;
            if (!id) return;
            var wishlisted = isWishlisted(id);
            btn.classList.toggle('is-wishlisted', wishlisted);
            btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
            btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              toggleWishlist(id);
            });
          });
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();